<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
// import Input from "@/components/c-input";
// import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import { propertyService } from "../../../../services/managements/propertyservice/property.service";
import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Monthly Bill Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    // Input,
    Select,
    Search,
  },
  data() {
    return {
      dropdownSelection: {},
   
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Monthly Bill",
      breadCrumb: {},
      monthlyBillingDateList: [
        {id: 1, label: 'ថ្ងៃទី 01'},
        {id: 2, label: 'ថ្ងៃទី 02'},
        {id: 3, label: 'ថ្ងៃទី 03'},
        {id: 4, label: 'ថ្ងៃទី 04'},
        {id: 5, label: 'ថ្ងៃទី 05'},
        {id: 6, label: 'ថ្ងៃទី 06'},
        {id: 7, label: 'ថ្ងៃទី 07'},
        {id: 8, label: 'ថ្ងៃទី 08'},
        {id: 9, label: 'ថ្ងៃទី 09'},
        {id: 10, label: 'ថ្ងៃទី 10'},
        {id: 11, label: 'ថ្ងៃទី 11'},
        {id: 12, label: 'ថ្ងៃទី 12'},
        {id: 13, label: 'ថ្ងៃទី 13'},
        {id: 14, label: 'ថ្ងៃទី 14'},
        {id: 15, label: 'ថ្ងៃទី 15'},
        {id: 16, label: 'ថ្ងៃទី 16'},
        {id: 17, label: 'ថ្ងៃទី 17'},
        {id: 18, label: 'ថ្ងៃទី 18'},
        {id: 19, label: 'ថ្ងៃទី 19'},
        {id: 20, label: 'ថ្ងៃទី 20'},
        {id: 21, label: 'ថ្ងៃទី 21'},
        {id: 22, label: 'ថ្ងៃទី 22'},
        {id: 23, label: 'ថ្ងៃទី 23'},
        {id: 24, label: 'ថ្ងៃទី 24'},
        {id: 25, label: 'ថ្ងៃទី 25'},
        {id: 26, label: 'ថ្ងៃទី 26'},
        {id: 27, label: 'ថ្ងៃទី 27'},
        {id: 28, label: 'ថ្ងៃទី 28'},
        {id: 29, label: 'ថ្ងៃទី 29'},
        {id: 30, label: 'ថ្ងៃទី 30'},
        {id: 31, label: 'ថ្ងៃទី 31'}
      ],

      projectData: {},
      propertyData: {},
      propertySelected: {},

      dataProject: 1,
      dataLastProject: 0,
      dataProperty: 0,
      dataBillingDate: 0
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }
  },
 
  methods: {
    loadingData: function(id) {
      this.fetchingStats = true;
      propertyService.getOne(id)
        .then(response => {
          if(id != 0){
            this.dataProject = response.data.project_id;
            this.dataProperty = response.data.id;
            this.dataBillingDate = response.data.monthly_billing_date;
          }
          this.loadingSettings(response.setting);
        });

    },

   
    loadingPropertyById: function(id) {

      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          this.fetchingStats = true;
          this.propertySelected = response.data;
          this.dataProperty = this.propertySelected.id;
          // this.loadingSettings(response.setting);
        });
    },

    loadingPropertyData: function(projectId = 0) {
      propertyService.getDropdowns(projectId).then(response => {
        this.propertyData = response;
      });
    },


    loadingSettings: function(setting) {
      this.projectData = {data: setting.projects};
      this.propertyData = {data: setting.properties};
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-property"
          });

        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;

      let dataSubmit = {
        project_id: this.dataProject,
        property_id: this.dataProperty,
        monthly_billing_date: this.dataBillingDate,

      };

        propertyService.updateMonlyBilling(dataSubmit)
         .then(response => {
           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-property"
                });
              } 
            });
           }else{
             console.log(dataSubmit)

           }
          
        });
    
    },


    clearForm: function() {

      this.dataProperty = 0;

    },

    projectChanged: function(event) {

      this.project = event;
      if(this.dataLastProject != 0) {
        this.loadingPropertyData(this.project);
      }
      this.dataLastProject = event;
    },

    propertyChanged: function(property) {
      this.loadingPropertyById(property.id);      
    },

  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :items="[{
        text: $t('property.text'),
        href: '/manage/property',
      }, {
        text: $t('manage.setting-monthly-billing-date'),
        active: true
      }]" :title="$t('manage.setting-monthly-billing-date')" />
    </div>
    

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
            <div class="row">
                <div class="col-md-4">
                <Select
                  @change="projectChanged" 
                  :id="'project_id'"
                  :editable="false"
                  v-model="dataProject"
                  :list="this.projectData"
                  :label="'property.project'"
                  :require="true"
                    /> 
              </div>
              <div class="col-lg-4">
                <Search 
                  :id="'property_id'"
                  :editable="true"
                  v-model="dataProperty"
                  :list="this.propertyData"
                  :label="'property.text'" 
                />
              </div>

              
            </div>
            <div class="row">
              <div class="col-md-4">
                <Select
                  :id="'monthly_billing_date'"
                  v-model="dataBillingDate"
                  :list="{data:monthlyBillingDateList}"
                  :label="'manage.monthly-billing-date'"
                  :require="true"
                  /> 
              </div>
            </div>
   
            <br>
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>